// src/sites/SeitenKopf.jsx
//
// WARUM ES DAS GIBT:
// Die Seite ist eine einzige React-Anwendung. Alle Adressen (/, /imprint,
// /tos ...) liefern DIESELBE index.html und damit denselben <title> und
// dieselbe Beschreibung. Fuer das Impressum ist das egal, fuer eine Seite,
// die bei Google gefunden werden soll, ist es schaedlich: der Titel ist
// eines der staerksten Signale, und "Auto verkaufen in Loerrach" passt
// nicht zu einer Seite ueber die Schweiz.
//
// Dieser Helfer setzt Titel, Beschreibung und Canonical beim Oeffnen der
// Seite und stellt beim Verlassen den Ausgangszustand wieder her.
//
// EHRLICHE GRENZE: Google fuehrt JavaScript aus und sieht den gesetzten
// Titel, aber erst beim zweiten Durchgang (Rendering). Das dauert laenger
// als bei einer Seite, die den Titel schon im Quelltext mitbringt.
import { useEffect } from "react";

// Ausgangswerte EINMAL beim Laden merken, nicht bei jedem Aufruf. Sonst
// merkt sich die zweite Seite den Titel der ersten als "Original".
const STANDARD_TITEL = typeof document !== "undefined" ? document.title : "";
const STANDARD_BESCHREIBUNG =
  typeof document !== "undefined"
    ? document.querySelector('meta[name="description"]')?.content || ""
    : "";

function setzeMeta(name, wert) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", wert);
}

function setzeCanonical(pfad) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", `https://www.auto-mah.com${pfad}`);
}

export default function SeitenKopf({ titel, beschreibung, pfad }) {
  useEffect(() => {
    if (titel) document.title = titel;
    if (beschreibung) setzeMeta("description", beschreibung);
    if (pfad) setzeCanonical(pfad);

    return () => {
      document.title = STANDARD_TITEL;
      setzeMeta("description", STANDARD_BESCHREIBUNG);
      setzeCanonical("/");
    };
  }, [titel, beschreibung, pfad]);

  return null;
}
